import axios from 'axios';

// API URL - même backend que Reaktor
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://roue-des-emotions-reaktor.spmerchflow.com:8001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Pour FormData, laisser Axios définir le Content-Type avec le boundary correct
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // Pour la route de login OAuth2, utiliser form-urlencoded
    else if (config.url === '/auth/login' && config.data instanceof URLSearchParams) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // Vérifier que la réponse contient des données JSON valides
    if (response.data === undefined || response.data === null) {
      return response;
    }
    return response;
  },
  (error) => {
    // Gestion des erreurs réseau
    if (!error.response && error.request) {
      error.code = 'ERR_NETWORK';
      error.message = 'Erreur réseau - Impossible de contacter le serveur';
    }
    // Gestion des erreurs de parsing JSON
    else if (error.message && error.message.includes('JSON.parse')) {
      error.code = 'ERR_BAD_RESPONSE';
      error.message = 'Données corrompues - La réponse est trop longue ou invalide';
    }
    // Gestion des erreurs 401
    else if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_info');
      window.location.href = '/login';
    }
    // Gestion des erreurs 413 (Payload Too Large)
    else if (error.response?.status === 413) {
      error.message = 'Trop de données - Veuillez filtrer votre recherche';
    }
    // Gestion des erreurs 500
    else if (error.response?.status === 500) {
      error.message = 'Erreur serveur - Veuillez réessayer plus tard';
    }
    return Promise.reject(error);
  }
);

export default api;
